import { Controller } from "@hotwired/stimulus";
import { submitKitMessage } from "utils/kitChatSubmit";

// Drives the inline "choices" block. Single-select sends the chosen option
// immediately; multi-select toggles options then sends on "Send". "Skip" sends
// a short message so the (halted) agent can continue. Once answered, the card
// locks and shows what was chosen.
export default class extends Controller {
  static values = { chatId: Number, messageId: Number, multiSelect: Boolean };
  static targets = ["option", "send"];

  connect() {
    if (this.multiSelectValue && this.hasSendTarget) {
      this.sendTarget.disabled = true;
    }
  }

  select(event) {
    this.markChosen([event.currentTarget]);
    this.lockAndSend(event.params.message, event.params.label);
  }

  toggle(event) {
    event.currentTarget.classList.toggle("is-selected");
    if (this.hasSendTarget) {
      this.sendTarget.disabled = !this.selectedOptions().length;
    }
  }

  send() {
    const chosen = this.selectedOptions();
    if (!chosen.length) return;

    const messages = chosen.map((o) => o.dataset.kitChoicesMessageParam);
    const labels = chosen.map((o) => o.dataset.kitChoicesLabelParam);
    this.lockAndSend(messages.join("; "), labels.join(", "));
  }

  skip() {
    this.lock("Skipped");
    submitKitMessage(this.chatIdValue, "Let's skip that question.");
  }

  // Private

  selectedOptions() {
    return this.optionTargets.filter((o) =>
      o.classList.contains("is-selected")
    );
  }

  markChosen(elements) {
    this.optionTargets.forEach((o) => o.classList.remove("is-selected"));
    elements.forEach((o) => o.classList.add("is-selected"));
  }

  lockAndSend(message, answerLabel) {
    this.lock(answerLabel);
    submitKitMessage(this.chatIdValue, message);
  }

  lock(answerLabel) {
    this.element.classList.add("is-answered");
    this.optionTargets.forEach((o) => (o.disabled = true));
    if (this.hasSendTarget) this.sendTarget.disabled = true;

    if (answerLabel) {
      const note = document.createElement("div");
      note.className = "kit-choices__answered";
      note.textContent = `✓ ${answerLabel}`;
      this.element.appendChild(note);
    }
  }
}
